interface HeroSectionProps {
  onEstimateClick: () => void;
}

export default function HeroSection({ onEstimateClick }: HeroSectionProps) {
  return (
    <section className="relative w-full h-screen min-h-[680px] flex items-center justify-center overflow-hidden">
      {/* Video Background */}
      <video
        autoPlay
        muted
        loop
        playsInline
        className="absolute inset-0 w-full h-full object-cover object-center"
      >
        <source src="https://downsconstructionllc.com/images/downsherobg.mp4" type="video/mp4" />
      </video>

      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-black/65 via-black/55 to-black/70"></div>

      {/* Navy accent strip at bottom */}
      <div className="absolute bottom-0 left-0 right-0 h-1 bg-gradient-to-r from-primary via-primary-mid to-primary"></div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-5xl mx-auto px-6 sm:px-8 text-center animate-fadeUp">
        <div className="inline-flex items-center gap-2 mb-5">
          <div className="w-8 h-px bg-primary-mid"></div>
          <span className="text-primary-light text-xs font-bold uppercase tracking-[0.3em]">
            Michigan&apos;s Trusted Construction Experts
          </span>
          <div className="w-8 h-px bg-primary-mid"></div>
        </div>
        <h1 className="text-4xl sm:text-5xl lg:text-7xl font-black uppercase text-white leading-tight tracking-tight mb-6" style={{ fontFamily: "'Barlow Condensed', sans-serif" }}>
          Home Additions, Renovations &amp; Pole Barns Built to Last
        </h1>
        <p className="text-gray-300 text-sm sm:text-base lg:text-lg max-w-2xl mx-auto leading-relaxed mb-10">
          With 29+ years of experience, we specialize in custom home additions, full-scale renovations, and durable pole barn construction. Our team delivers clean, high-quality workmanship backed by integrity and exceptional service.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <button
            onClick={onEstimateClick}
            className="bg-primary hover:bg-primary-dark text-white text-sm font-bold uppercase tracking-widest px-8 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap btn-press animate-pulse-glow"
          >
            Get a Free Estimate
          </button>
          <a
            href="#services"
            className="border-2 border-white/70 hover:border-white text-white hover:bg-white/10 text-sm font-bold uppercase tracking-widest px-8 py-4 rounded-md transition-all duration-200 cursor-pointer whitespace-nowrap flex items-center justify-center gap-2"
          >
            View Our Services
            <i className="ri-arrow-down-line"></i>
          </a>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-10 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/50 text-xs uppercase tracking-widest">Scroll</span>
        <i className="ri-arrow-down-line text-white/50 text-xl"></i>
      </div>
    </section>
  );
}
